export const environment = {
  url: {
    api: `https://apim-dev.houseofhr.com/square-app-prodigy/api/v2.0`,
  },
  production: false,
  ocpApimSubscriptionKey: 'c46f7f8305334ad5850cba46c3163850'
};

